import { window } from "global";
import { graphqlURI } from "api/devConstants";

const REGIONAL_URLS = ["na.u.gg", "eu.u.gg", "kr.u.gg", "sa.u.gg", "oce.u.gg"];

export function getWsUrl() {
  let ws = process.env.UPDATE_WS_URL;
  if (window && window.location) {
    if (REGIONAL_URLS.includes(window.location.hostname)) {
      ws = `wss://${window.location.hostname}`;
    }
  }
  return ws;
}

export function getGraphQlUrl() {
  let newGraphQlUri = graphqlURI;
  if (window && window.location) {
    if (REGIONAL_URLS.includes(window.location.hostname)) {
      newGraphQlUri = `https://${window.location.hostname}/api`;
    }
  }
  return newGraphQlUri;
}
